import _defineProperty from "/Users/martin/DEV/DFN_VEOMED-dfn/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/martin/DEV/DFN_VEOMED-dfn/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "theme", "toastOptions"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/chakra-provider.tsx
import { ChakraProvider as BaseChakraProvider } from "@chakra-ui/provider";
import { theme as defaultTheme, baseTheme } from "@chakra-ui/theme";
import { ToastProvider, ToastOptionProvider } from "@chakra-ui/toast";
import { jsx, jsxs } from "react/jsx-runtime";
var createChakraProvider = function createChakraProvider(providerTheme) {
  return function ChakraProvider2(_ref) {
    var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? providerTheme : _ref$theme,
      toastOptions = _ref.toastOptions,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return /* @__PURE__ */jsxs(BaseChakraProvider, _objectSpread(_objectSpread({
      theme: theme
    }, restProps), {}, {
      children: [/* @__PURE__ */jsx(ToastOptionProvider, {
        value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
        children: children
      }), /* @__PURE__ */jsx(ToastProvider, _objectSpread({}, toastOptions))]
    }));
  };
};
var ChakraProvider = createChakraProvider(defaultTheme);
var ChakraBaseProvider = createChakraProvider(baseTheme);
export { ChakraProvider, ChakraBaseProvider };